import React, { useState, useEffect } from "react";
import { GOLD, tf, ts } from "./data";
import { useContent, EditableText, ReorderControls } from "./content";

export default function Signatures() {
  const { content, isAdmin } = useContent();
  const travellers = content.signatures || [];

  return (
    <div className="jp-page" data-testid="signatures-view">
      <div className="jp-page-inner narrow">
        <h2 className="jp-h2">Family Signatures</h2>
        <p className="jp-h2-sub">A few words from each of us · in our own hand</p>

        <div className="jp-sig-grid" data-testid="sig-grid">
          {travellers.map((t, i) => (
            <SignatureCard
              key={`${t.name}-${i}`}
              t={t}
              idx={i}
              total={travellers.length}
              delay={i * 110}
              isAdmin={isAdmin}
            />
          ))}
        </div>

        <div className="jp-sig-stamp" data-testid="trip-stamp">
          <div className="jp-sig-stamp-inner">
            <div className="jp-sig-stamp-kanji">旅</div>
            <div>
              <div style={{ ...ts, fontSize: "1.1rem" }}>Trip Complete</div>
              <div style={{ ...tf, color: "rgba(255,255,255,0.5)", fontSize: "0.78rem" }}>
                4 May → 17 May 2026 · 13 nights · 4 cities · 3 hearts full
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SignatureCard({ t, idx, total, delay, isAdmin }) {
  const [reveal, setReveal] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => setReveal(true), delay + 700);
    return () => clearTimeout(id);
  }, [delay]);

  return (
    <div
      className="jp-sig-card"
      onMouseEnter={() => setReveal(true)}
      data-testid={`sig-card-${(t.name || "").toLowerCase().replace(/\s/g, "-")}`}
      style={{
        animationDelay: `${delay}ms`,
        background: `linear-gradient(135deg, ${t.accent}55, ${t.accent}22)`,
        borderColor: `${t.accent}66`,
      }}
    >
      <ReorderControls section="signatures" index={idx} total={total} label={t.name} />
      <div className="jp-sig-corner" style={{ borderColor: GOLD }}>
        <div className="jp-sig-corner-tl" />
        <div className="jp-sig-corner-br" />
      </div>

      <EditableText
        path={["signatures", idx, "name"]}
        value={t.name}
        className="jp-sig-name"
        as="div"
        testId={`sig-${idx}-name`}
      />
      <EditableText
        path={["signatures", idx, "role"]}
        value={t.role}
        className="jp-sig-role"
        as="div"
        testId={`sig-${idx}-role`}
      />
      <p className="jp-sig-quote">
        &ldquo;
        <EditableText
          path={["signatures", idx, "quote"]}
          value={t.quote}
          multiline
          as="span"
          testId={`sig-${idx}-quote`}
        />
        &rdquo;
      </p>
      <div className="jp-sig-fav">
        <span style={{ color: GOLD }}>★</span>{" "}
        <EditableText
          path={["signatures", idx, "favourite"]}
          value={t.favourite}
          as="span"
          testId={`sig-${idx}-favourite`}
        />
      </div>
      <div className={`jp-sig-signature ${reveal || isAdmin ? "reveal" : ""}`}>
        <EditableText
          path={["signatures", idx, "signature"]}
          value={t.signature}
          as="span"
          testId={`sig-${idx}-signature`}
        />
      </div>
    </div>
  );
}
